import { render, staticRenderFns } from "./BaseDropdown.vue?vue&type=template&id=530b6e78&scoped=true&"
import script from "./BaseDropdown.vue?vue&type=script&lang=ts&"
export * from "./BaseDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDropdown.vue?vue&type=style&index=0&id=530b6e78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530b6e78",
  null
  
)

export default component.exports